import { Edit3, GripVertical, Tag, Trash2 } from "lucide-react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function CatalogCategoryRow({ category, productCount, isMain, onEdit, onAskDelete }) {
  const sortable = useSortable({ id: category.id, disabled: !isMain });
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = sortable;
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 10 : "auto",
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center gap-3 md:gap-4 px-4 md:px-5 py-4 transition-colors ${
        isDragging ? "bg-[#F3EFE7]" : "hover:bg-[#FBF8F1]"
      }`}
      data-testid={`category-row-${category.id}`}
    >
      {isMain && (
        <button
          type="button"
          {...attributes}
          {...listeners}
          aria-label="Drag to reorder"
          data-testid={`category-drag-${category.id}`}
          className="h-8 w-6 -ml-1 mr-1 shrink-0 flex items-center justify-center text-[#0B1F3A]/40 hover:text-[#0B1F3A]/70 cursor-grab active:cursor-grabbing touch-none"
        >
          <GripVertical size={16} />
        </button>
      )}
      <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0 bg-[#EDEAE2] text-[#0B1F3A]">
        <Tag size={18} strokeWidth={1.8} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#0B1F3A]">{category.name}</p>
        <p className="text-xs text-[#0B1F3A]/60 mt-0.5">
          {productCount} product{productCount === 1 ? "" : "s"}
        </p>
      </div>
      {isMain && (
        <div className="flex gap-1 shrink-0">
          <button
            data-testid={`category-edit-${category.id}`}
            onClick={onEdit}
            className="h-8 w-8 rounded-md hover:bg-[#F3EFE7] flex items-center justify-center text-[#0B1F3A]/70 hover:text-[#0B1F3A] transition-colors"
            title="Edit"
          >
            <Edit3 size={14} />
          </button>
          <button
            data-testid={`category-delete-${category.id}`}
            onClick={onAskDelete}
            className="h-8 w-8 rounded-md hover:bg-red-50 flex items-center justify-center text-[#0B1F3A]/60 hover:text-red-600 transition-colors"
            title="Delete"
          >
            <Trash2 size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
